import { AlertTriangle, Clock } from 'lucide-react';

/**
 * RestPeriodWarning - Zeigt Ruhezeitwarnungen nach § 5 ArbZG an
 * 
 * Props:
 * - warning: Objekt mit Ruhezeitinformationen vom Backend
 *   {violation_before, violation_after, rest_before_hours, rest_after_hours, required_hours, messages}
 * - compact: Kompakte Darstellung für Listen
 */
export default function RestPeriodWarning({ warning, compact = false }) {
  if (!warning) return null;
  
  const { violation_before, violation_after, rest_before_hours, rest_after_hours, required_hours, messages } = warning;
  
  if (!violation_before && !violation_after) return null;
  
  if (compact) {
    return (
      <div className="flex items-center gap-1 text-amber-600 dark:text-amber-400" title={messages?.[0] || 'Ruhezeitverletzung'}>
        <Clock className="w-3 h-3" />
        <span className="text-xs">
          {violation_before && rest_before_hours !== null && `${rest_before_hours?.toFixed(1)}h`}
          {violation_before && violation_after && ' / '}
          {violation_after && rest_after_hours !== null && `${rest_after_hours?.toFixed(1)}h`}
        </span>
      </div>
    );
  }
  
  return (
    <div className="bg-amber-500/10 border border-amber-500/30 rounded-lg p-3 text-sm" data-testid="rest-period-warning">
      <div className="flex items-center gap-2 text-amber-600 dark:text-amber-400 font-medium mb-1">
        <AlertTriangle className="w-4 h-4" />
        Ruhezeithinweis (§ 5 ArbZG)
      </div>
      <div className="space-y-1 text-amber-700 dark:text-amber-300/80">
        {messages?.map((msg, idx) => (
          <p key={idx}>{msg}</p>
        ))}
      </div>
      <p className="text-xs text-amber-600 dark:text-amber-400/60 mt-2">
        Der Eintrag kann trotzdem gespeichert werden. Vorgesetzte werden benachrichtigt.
      </p>
    </div>
  );
}


/**
 * RestPeriodIndicator - Kleines Symbol für Tagesübergänge in der Wochenansicht
 */
export function RestPeriodIndicator({ violationBefore, violationAfter, restBeforeHours, restAfterHours }) {
  const hasViolation = violationBefore || violationAfter;
  
  if (!hasViolation) return null;
  
  const title = [];
  if (violationBefore && restBeforeHours !== null) {
    title.push(`Ruhezeit vom Vortag: ${restBeforeHours?.toFixed(1)}h`);
  }
  if (violationAfter && restAfterHours !== null) {
    title.push(`Ruhezeit zum Folgetag: ${restAfterHours?.toFixed(1)}h`);
  }
  
  return (
    <div
      className="inline-flex items-center justify-center w-5 h-5 rounded-full bg-amber-500/20 text-amber-400"
      title={title.join('\n') + '\nMind. 11h nach § 5 ArbZG erforderlich'}
      data-testid="rest-period-indicator"
    >
      <Clock className="w-3 h-3" />
    </div>
  );
}
